/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InitiateRefundResponse
 */
export interface InitiateRefundResponse {
    /**
     * 
     * @type {InitiateRefundResponsePaymentStateEnum}
     * @memberof InitiateRefundResponse
     */
    paymentState: InitiateRefundResponsePaymentStateEnum;
    /**
     * 
     * @type {string}
     * @memberof InitiateRefundResponse
     */
    refundReference: string;
    /**
     * 
     * @type {string}
     * @memberof InitiateRefundResponse
     */
    softpayRequestId?: string;
}


/**
 * @export
 */
export const InitiateRefundResponsePaymentStateEnum = {
    INITIATING: 'INITIATING',
    AWAITING_PAYMENT: 'AWAITING_PAYMENT',
    AUTHORISING: 'AUTHORISING',
    AUTHORISED: 'AUTHORISED',
    CAPTURING: 'CAPTURING',
    CAPTURED: 'CAPTURED',
    PARTIALLY_REFUNDED: 'PARTIALLY_REFUNDED',
    FULLY_REFUNDED: 'FULLY_REFUNDED',
    FAILED: 'FAILED',
    UNKNOWN: 'UNKNOWN',
    REFUNDING: 'REFUNDING'
} as const;
export type InitiateRefundResponsePaymentStateEnum = typeof InitiateRefundResponsePaymentStateEnum[keyof typeof InitiateRefundResponsePaymentStateEnum];


/**
 * Check if a given object implements the InitiateRefundResponse interface.
 */
export function instanceOfInitiateRefundResponse(value: object): value is InitiateRefundResponse {
    if (!('paymentState' in value) || value['paymentState'] === undefined) return false;
    if (!('refundReference' in value) || value['refundReference'] === undefined) return false;
    return true;
}

export function InitiateRefundResponseFromJSON(json: any): InitiateRefundResponse {
    return InitiateRefundResponseFromJSONTyped(json, false);
}

export function InitiateRefundResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InitiateRefundResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'paymentState': json['paymentState'],
        'refundReference': json['refundReference'],
        'softpayRequestId': json['softpayRequestId'] == null ? undefined : json['softpayRequestId'],
    };
}

export function InitiateRefundResponseToJSON(json: any): InitiateRefundResponse {
    return InitiateRefundResponseToJSONTyped(json, false);
}

export function InitiateRefundResponseToJSONTyped(value?: InitiateRefundResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paymentState': value['paymentState'],
        'refundReference': value['refundReference'],
        'softpayRequestId': value['softpayRequestId'],
    };
}

